import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SideBar from "../Components/SideBar";
import config from "../Config.json";
import { DeleteBlogApi, GetBlogApi } from "../callApi/blog";

export default function AdminBlog() {
  const storedData = localStorage.getItem("adminData") || " {}";
  const adminData = JSON.parse(storedData);
  const AdminId = adminData.AdminId || null;
  const [data, setData] = useState([]);
  useEffect(() => {
    GetBlogApi("blogs").then((res) => {
      setData(res);
    });
  }, []);

  const handleDelete = (_id) => {
    const params ={
      AdminId: AdminId}
    DeleteBlogApi(_id, params).then((res) => {
      setData((data2) => data2.filter((item) => item._id != _id));
    });
  };
  return (
    <div className="admin-blog">
      <SideBar />
      <div className="admin-container">
        <div className="sec">
          <div className="blog-heading-button">
            <h1>Blog Posts</h1>
            <button className="add_blog">
              <Link to="/admin/blog/add" className="add-blog-post">
                + Add blog post
              </Link>
            </button>
          </div>
          <div className="all-blogs">
            {data.length > 0 ? (
              data.map((item) => (
                // <Link
                //   key={item._id}
                //   to={`/admin/blog/edit/${item._id}`}
                //   className="edit-blog-post"
                // >
                <div className="edit-blog-post">
                  <img
                    src={config.awsMediaPath + item.feature_image}
                    className="admin-blog-images"
                  />
                  <div className="content-blog">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                    <section
                      style={{ width: "100%" }}
                      className="author-status-section"
                    >
                      <p>
                        <strong>Created By:</strong> {item.FirstName}
                        {item.adminLastName}
                      </p>
                      <span>
                        <strong>Status:</strong> {item.status}
                      </span>
                    </section>
                    <div className="button-Container">
                      <Link
                        key={item._id}
                        to={`/admin/blog/edit/${item._id}`}
                        className="read-more-button"
                      >
                        <button type="button" className="content-buttons">
                          Read More...
                        </button>
                      </Link>
                      <button
                        type="button"
                        onClick={() => handleDelete(item._id)}
                        className="content-buttons"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
                // </Link>
              ))
            ) : (
              <div>
                <p>No records found</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
